/* ============================================================
   MA second-pair offer: cart state → body class

   Keeps body.ma-pairs-{0|1|2} in sync with how many eligible pairs
   (product type "Shoes") are in the cart. Everything visual hangs off
   that class: ma-pair-price (full vs half price), the PDP offer block
   (ma-second-pair-offer), and the cart drawer nudge. Liquid sets the
   initial class in theme.liquid; this script updates it after the
   Prestige cart events without a reload.
   ============================================================ */
(function () {
  'use strict';

  var CLASS_PREFIX = 'ma-pairs-';

  function countPairs(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var pairs = 0;
    cart.items.forEach(function (item) {
      var type = String(item.product_type || '').toLowerCase();
      if (type === 'shoes' && !item.gift_card) {
        pairs += item.quantity || 0;
      }
    });
    return pairs;
  }

  function applyState(pairs) {
    if (pairs === null || pairs === undefined) return;
    var state = pairs >= 2 ? 2 : pairs;
    var body = document.body;
    body.classList.remove(CLASS_PREFIX + '0', CLASS_PREFIX + '1', CLASS_PREFIX + '2');
    body.classList.add(CLASS_PREFIX + state);
    body.dataset.maPairs = String(pairs);
    document.dispatchEvent(new CustomEvent('ma:pairs-change', { detail: { pairs: pairs } }));
  }

  function refreshFromServer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyState(countPairs(cart)); })
      .catch(function () {});
  }

  // Prestige dispatches cart:change with the full cart payload after add,
  // quantity change and removal. cart:refresh fires without a payload.
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    var pairs = countPairs(cart);
    if (pairs === null) {
      refreshFromServer();
    } else {
      applyState(pairs);
    }
  });
  document.addEventListener('cart:refresh', refreshFromServer);

  // Pages can be served from the browser cache after a cart change on
  // another page, so reconcile once on load and again when a page is
  // restored from the back-forward cache.
  refreshFromServer();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshFromServer();
  });
})();
